export const ROOT_TAG = "enterprise-product-experience-bridge-bar";

/**
 * Document-level event broadcast to request that every open Bridge Bar child
 * component (e.g. the application switcher, the user profile menu) collapse
 * itself. Dispatched by {@link BBContainerElement.collapseComponents} — and
 * indirectly by the public `collapseComponents()` API on the root element —
 * so parent → child collapse stays decoupled from the children's internal
 * open state. Children that close in response re-emit `component-collapsed`,
 * which drives the container's overlay state through the existing flow.
 */
export const COLLAPSE_COMPONENTS_EVENT = "bridge-bar-collapse-components";

/**
 * Fired on `document` when the user changes their active organization context
 * in the Org Context Selector. Adopting apps listen for this to re-scope their
 * data to the selected org. `detail` carries `{ commonOrgId, displayName, source }`.
 */
export const CONTEXT_CHANGED_EVENT = "bridge-bar-context-changed";

/**
 * Internal: the org context selector telling the container whether it has
 * anything to show, so the container knows whether to make room for it. Not part
 * of the adopter-facing event surface — `detail.present` is false only when
 * membership resolved with zero entities, which is the one case where the
 * selector is definitively never going to appear for this user.
 */
export const ORG_SELECTOR_PRESENCE_EVENT = "bridge-bar-org-selector-presence";
